import CardData from './CardData';
import type { CardCity, CardProperties, CardRating, CardRawData } from './CardData';
import type { GeoFieldPoint } from './GeoLocation';
import {LocaleService} from "../common/LocaleService";

/** Datos crudos de un POI, tal cual llegan del detalle REST. */
export interface PoiCardRawData extends CardRawData {
    poi_geopos: GeoFieldPoint;
    field_poi_rating?: CardRating[];
    poi_desc: { value: string };
    poi_more: { url?: string; title?: string };
    poi_city_entity_reference: CardCity;
    poi_type_reference: { id: string };
}

/**
 * CardData - City, Hotel
 *
 * Data wrapper for object types:
 * - Accommodation (Hotel, Hostel)
 * - Place (City, Monument)
 */
class PoiCard extends CardData {

    // Solo estrecha el tipo del campo de CardData: `declare` no emite nada.
    declare data: PoiCardRawData;

    /** Termino de tipo de POI. Lo lee CardInfo para decidir si hay valoracion. */
    poiTypeReference?: string;

    constructor(type: string, properties: CardProperties, data: PoiCardRawData) {
        super(type, properties, data);

        this.title = data.title && LocaleService.decodeHtmlEntities(data.title);
        this.geo_location = { lon: data.poi_geopos.lon, lat: data.poi_geopos.lat };
        this.rating = data.field_poi_rating && data.field_poi_rating[0];
        this.extra_html = LocaleService.decodeHtmlEntities(data.poi_desc.value);
        this.poiUrl = {
            url: data.poi_more?.url,
            title: data.poi_more.title ? LocaleService.decodeHtmlEntities(data.poi_more.title) :  null};
        this.city = data.poi_city_entity_reference;
        this.poiTypeReference = data.poi_type_reference.id;
        this.link = null;
    }
}

export default PoiCard;
